import { render, staticRenderFns } from "./entrega-elementos.vue?vue&type=template&id=8eb1efa4&scoped=true&"
import script from "./entrega-elementos.vue?vue&type=script&lang=js&"
export * from "./entrega-elementos.vue?vue&type=script&lang=js&"
import style0 from "./entrega-elementos.vue?vue&type=style&index=0&id=8eb1efa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb1efa4",
  null
  
)

export default component.exports